module.exports = __webpack_public_path__ + "media/fx1.8fb75c98.wav";